module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("TRANSLATOR’S NOTE")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WHEN I CAME ACROSS")]), _vm._v(" the original private publication of these letters a few years ago, I was fascinated by the many aspects of American life in 1869 that are vividly reported. As one of the Mendelssohn family, I initially intended to translate this book for the many members of the clan who now live in this country and no longer speak German. However, I came to believe that these pages would be of interest to a larger public because they illustrate the vantage point of an educated European who spouts Latin quotations (for better or worse) and compares his experiences to his travels in Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("My thanks go to Gertrud Champe, who spent many hours making this translation idiomatic and flowing, and Jon Thiem, who helped us with his knowledge of the literature on the Mendelssohns and who was the first to discover the original book, as it was published privately in the nineteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Barbara H. Thiem")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282edd8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Fm01.vue
// module id = 72
// module chunks = 0